import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { environment } from 'src/environments/environment';

import { SocialLoginModule, SocialAuthServiceConfig, GoogleLoginProvider } from '@abacritt/angularx-social-login';/* , FacebookLoginProvider */

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule, HttpLoaderFactory } from './_core/shared.module';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { PopUpComponent } from './components/pop-up/pop-up.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ToastComponent } from './components/toast/toast.component';

@NgModule({
  declarations: [
    AppComponent,
    SideNavComponent,
    PopUpComponent,
    ToastComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SocialLoginModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider('298861866748-3gottcepi7mpnus440g1308ldpjmb7vi.apps.googleusercontent.com')
          },
          /* {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider('817727885473737')
          } */
        ]
      } as SocialAuthServiceConfig,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }